export default {
  // 页面标题与状态
  'pages.accountB.generateLog.title': 'B账生成日志',
  'pages.accountB.generateLog.emptyText': '暂无生成日志',
  'pages.accountB.generateLog.msg.queryFailed': '查询生成日志失败',
  'pages.accountB.generateLog.msg.detailFailed': '加载生成日志详情失败',
  'pages.accountB.generateLog.msg.retry': '重试',
  'pages.accountB.generateLog.msg.copy': '复制',
  'pages.accountB.generateLog.msg.copied': '已复制',
  'pages.accountB.generateLog.tooltip.nameNotBackfilled':
    '名称未回填,回退显示ID',

  // 搜索区(全部=不筛选)
  'pages.accountB.generateLog.search.all': '全部',
  'pages.accountB.generateLog.search.tenant': '租户',
  'pages.accountB.generateLog.search.tenant.placeholder': '请选择租户',
  'pages.accountB.generateLog.search.store': '门店',
  'pages.accountB.generateLog.search.store.placeholder': '请选择门店',
  'pages.accountB.generateLog.search.store.placeholderFirst': '请先选择租户',
  'pages.accountB.generateLog.search.pos': 'POS',
  'pages.accountB.generateLog.search.pos.placeholder': '请选择POS',
  'pages.accountB.generateLog.search.pos.placeholderFirst': '请先选择门店',
  'pages.accountB.generateLog.search.status': '状态',
  'pages.accountB.generateLog.search.triggerSource': '触发来源',
  'pages.accountB.generateLog.search.createTimeRange': '创建时间',

  // 列表列
  'pages.accountB.generateLog.column.id': '日志ID',
  'pages.accountB.generateLog.column.configId': '配置ID',
  'pages.accountB.generateLog.column.tenantName': '租户',
  'pages.accountB.generateLog.column.storeName': '门店',
  'pages.accountB.generateLog.column.pos': 'POS',
  'pages.accountB.generateLog.column.dateRange': '日期范围',
  'pages.accountB.generateLog.column.triggerSource': '触发来源',
  'pages.accountB.generateLog.column.forceParam': '强制重算',
  'pages.accountB.generateLog.column.status': '状态',
  'pages.accountB.generateLog.column.generatedDays': '生成天数',
  'pages.accountB.generateLog.column.failedDate': '失败日期',
  'pages.accountB.generateLog.column.duration': '耗时(秒)',
  'pages.accountB.generateLog.column.lockConflict': '锁冲突',
  'pages.accountB.generateLog.column.createTime': '创建时间',
  'pages.accountB.generateLog.column.action': '操作',
  'pages.accountB.generateLog.action.detail': '查看详情',

  // 枚举翻译(未知值原样展示)
  'pages.accountB.generateLog.status.RUNNING': '执行中',
  'pages.accountB.generateLog.status.SUCCESS': '成功',
  'pages.accountB.generateLog.status.FAILED': '失败',
  // 需求偏差裁定:状态筛选/展示独立加 SKIPPED 档(锁冲突整体跳过,与 lock_conflict=1 伴生)
  'pages.accountB.generateLog.status.SKIPPED': '锁冲突(跳过)',
  'pages.accountB.generateLog.trigger.MANUAL': '手动触发',
  'pages.accountB.generateLog.trigger.JOB': '定时任务',
  'pages.accountB.generateLog.trigger.BACKFILL': '回填',
  'pages.accountB.generateLog.trigger.CLI': '命令行',
  'pages.accountB.generateLog.force.yes': '强制重算',
  'pages.accountB.generateLog.force.no': '常规',
  'pages.accountB.generateLog.lock.yes': '是',
  'pages.accountB.generateLog.lock.no': '否',

  // 详情弹窗
  'pages.accountB.generateLog.detail.title': '生成日志详情',
  'pages.accountB.generateLog.detail.refresh': '刷新',
  'pages.accountB.generateLog.detail.close': '关闭',
  'pages.accountB.generateLog.detail.loading': '加载中…',
  'pages.accountB.generateLog.detail.group.basic': '基本信息',
  'pages.accountB.generateLog.detail.group.params': '生成参数',
  'pages.accountB.generateLog.detail.group.caller': '调用信息',
  'pages.accountB.generateLog.detail.group.result': '执行结果',
  'pages.accountB.generateLog.detail.group.skipFail': '跳过与失败',
  'pages.accountB.generateLog.detail.group.time': '时间信息',
  'pages.accountB.generateLog.detail.id': '日志ID',
  'pages.accountB.generateLog.detail.configId': '配置ID',
  'pages.accountB.generateLog.detail.tenant': '租户',
  'pages.accountB.generateLog.detail.store': '门店',
  'pages.accountB.generateLog.detail.pos': 'POS',
  'pages.accountB.generateLog.detail.startDate': '起始日期',
  'pages.accountB.generateLog.detail.endDate': '结束日期',
  'pages.accountB.generateLog.detail.forceParam': '强制重算',
  'pages.accountB.generateLog.detail.triggerSource': '触发来源',
  'pages.accountB.generateLog.detail.caller': '调用人',
  'pages.accountB.generateLog.detail.callerIp': '调用IP',
  'pages.accountB.generateLog.detail.status': '状态',
  'pages.accountB.generateLog.detail.generatedDays': '生成天数',
  'pages.accountB.generateLog.detail.duration': '耗时(秒)',
  'pages.accountB.generateLog.detail.lockConflict': '锁冲突',
  'pages.accountB.generateLog.detail.skippedDays': '跳过日期',
  'pages.accountB.generateLog.detail.failedDate': '失败日期',
  'pages.accountB.generateLog.detail.errorMsg': '错误信息',
  'pages.accountB.generateLog.detail.createTime': '创建时间',
  'pages.accountB.generateLog.detail.updateTime': '更新时间',
};
